import "../../../callout.js";
import "../../../mixins/recoverable_error.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.InsuranceStep ??= {};

AppointmentBooking.Wizard.Views.InsuranceStep.ValidationErrorCallout = class ValidationErrorCallout extends (
  AppointmentBooking.Wizard.Views.Mixins.RecoverableError(AppointmentBooking.Wizard.Views.Callout)
) {};
AppointmentBooking.Wizard.Views.InsuranceStep.ValidationErrorCallout.prototype.template =
  "step/insurance/callouts/validation_error";
AppointmentBooking.Wizard.Views.InsuranceStep.ValidationErrorCallout.prototype.className =
  "appointment-booking-wizard-insurance-step-recoverable-error-callout borderless";
AppointmentBooking.Wizard.Views.InsuranceStep.ValidationErrorCallout.prototype.recoverableErrorTypes = [
  "base_epic_insurance_validation_error",
];
